import { reviewFindingsFixture } from "./fixtures/revisione";

export type Finding = { id: string; clause: string; title: string; explanation: string; proposal: string; reference: string; original: string; suggested: string; state: "pending" | "applied" | "ignored"; customProposal?: string };

export async function getReviewFindings(): Promise<Finding[]> {
  await new Promise((resolve) => setTimeout(resolve, 180));
  return reviewFindingsFixture.map((finding) => ({ ...finding }));
}

export function getInitialReviewFindings(): Finding[] { return reviewFindingsFixture.map((finding) => ({ ...finding })); }
